/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import React from "react";
import Backdrop from "@mui/material/Backdrop";
import { CircularProgress } from "@mui/material";
import { useTheme } from "@mui/styles";


const LoaderStatus = () => {
  const theme = useTheme();
  return (
    <Backdrop
      sx={{
        position: 'fixed',
        zIndex: 9999999,
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black
        color: theme.palette.text.color, // Using your existing color
      }}
      open={true} // Always visible in this component
    >
      <CircularProgress 
        size={50} 
        sx={{ 
          color: 'inherit', 
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }} 
      />
    </Backdrop>
  )
};

export default LoaderStatus;
